import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const Accordion = ({
	data,
	renderButton,
	renderChildren,
	className,
	buttonClassName,
	getRefs,
	onButtonClick,
	getContentHeight,
	activeItem,
	itemKey
}) => {
	const { header, content } = data;

	return (
		<div className={cx(styles.Accordion, className)} ref={getRefs(itemKey)}>
			<button
				type="button"
				onClick={() => onButtonClick(itemKey)}
				className={cx(buttonClassName, styles.Accordion_Button)}
			>
				{renderButton(header, activeItem === itemKey)}
			</button>
			<div
				className={styles.Accordion_Content}
				style={{
					height: getContentHeight(itemKey)
				}}
			>
				{renderChildren(content)}
			</div>
		</div>
	);
};

Accordion.propTypes = {
	renderButton: PropTypes.func.isRequired,
	renderChildren: PropTypes.func.isRequired,

	data: PropTypes.shape({
		header: PropTypes.string.isRequired,
		content: PropTypes.array
	}).isRequired,
	className: PropTypes.string,
	buttonClassName: PropTypes.string,
	getRefs: PropTypes.func,
	onButtonClick: PropTypes.func,
	getContentHeight: PropTypes.func,
	activeItem: PropTypes.string,
	itemKey: PropTypes.string
};

export default memo(Accordion);
